import dayjs from 'dayjs';
import { RURAL_URBAN, USER_TYPE } from './constant';

const getArrayValue = (value) => {
  if (value === '' || value === undefined || value === null) return [];
  return value;
};

export const buildCreateUserPayload = ({
  formState1,
  roleFormState,
  formStateForFacility,
  formStateForField,
  ruralUrban,
  isGrampanchayat,
  isVerified,
  hfrAbhaId,
  consentDetails,
  verificationProcessId,
}) => {
  const isFieldLevelUser = formState1.user_type.value === USER_TYPE.FIELD_LEVEL;
  const isFacilityFieldLevelUser =
    formState1.user_type.value === USER_TYPE.FACILITY_LEVEL ||
    formState1.user_type.value === USER_TYPE.FIELD_LEVEL;
  const isFacilityLevelUser = formState1.user_type.value === USER_TYPE.FACILITY_LEVEL;
  const isAbha = isFieldLevelUser;

  const consentNeededForABha = isAbha ? (isVerified ? hfrAbhaId : '') : '';
  const consentNeededForHPR = isAbha ? '' : isVerified ? hfrAbhaId : '';
  const consentNeeded = consentNeededForABha ? true : !!consentNeededForHPR;

  return {
    fName: formState1.fName?.value,
    lName: formState1.lName?.value,
    email: formState1.email?.value ?? '',
    mob: formState1.mob?.value,
    userDesignationId: formState1.designation?.id,
    doj: new Date(dayjs(formState1.doj?.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
    userTypeId: formState1.user_type?.id,
    mfa: roleFormState.mfa?.value,
    effectiveFromDt: new Date(dayjs(formState1.doj?.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
    volunteerForPmsma: formStateForFacility?.volunteerForPmsma?.value,
    userStatus: formState1.user_status?.value ? 'Active' : 'Inactive',
    reportUserWithLineListingData: roleFormState.reportUserWithLineListingData?.value,
    offlineModeAccess: roleFormState.offlineModeAccess?.value,
    stId: roleFormState.state?.id ?? '',
    stCode: roleFormState.state?.code ? Number(roleFormState.state?.code) : null,
    roleId: getArrayValue(roleFormState.role_name?.id),
    healthProviderId: isFieldLevelUser ? formStateForField.health_provider_tagged.id : [],
    mobiliserId: !isFieldLevelUser ? formStateForFacility.mobiliser_tagged.id : [],
    villageIds:
      ruralUrban === RURAL_URBAN.RURAL && !isGrampanchayat
        ? isFacilityLevelUser
          ? formStateForFacility.village?.id
          : formStateForField.village?.id
        : [],
    villageCodes:
      ruralUrban === RURAL_URBAN.RURAL && !isGrampanchayat
        ? isFacilityLevelUser
          ? formStateForFacility.village?.code
          : formStateForField.village?.code
        : [],
    gramPanchayatIds:
      ruralUrban === RURAL_URBAN.RURAL && isGrampanchayat
        ? isFacilityLevelUser
          ? formStateForFacility.gram_panchayat?.id
          : formStateForField.gram_panchayat?.id
        : [],
    gramPanchayatCodes:
      ruralUrban === RURAL_URBAN.RURAL && isGrampanchayat
        ? isFacilityLevelUser
          ? formStateForFacility.gram_panchayat?.code
          : formStateForField.gram_panchayat?.code
        : [],
    wardIds:
      ruralUrban === RURAL_URBAN.URBAN
        ? isFacilityLevelUser
          ? formStateForFacility.ward?.id
          : formStateForField.ward?.id
        : [],
    wardCodes:
      ruralUrban === RURAL_URBAN.URBAN
        ? isFacilityLevelUser
          ? formStateForFacility.ward?.code
          : formStateForField.ward?.code
        : [],
    mName: formState1?.middle_name?.value ?? '',
    alternateMob: formState1.a_mob?.value ?? '',
    abhaId: isAbha ? (isVerified ? hfrAbhaId : '') : '',
    hprId: isAbha ? '' : isVerified ? hfrAbhaId : '',
    zoneDivCircleId: getArrayValue(roleFormState.zone_div_circle?.id),
    compositeRoleId: getArrayValue(roleFormState.role_name?.compositeRoleId),
    distId: roleFormState.district?.id ?? '',
    distCode: roleFormState.district?.code ? Number(roleFormState.district?.code) : null,
    subDistId: roleFormState.sub_district?.id ?? '',
    ulbId: roleFormState.ulb?.id ?? '',
    blockId: roleFormState.block?.id ?? '',
    healthBlockId: roleFormState.health_block?.id ?? '',
    subDivisionId: roleFormState.sub_division?.id ?? '',
    pcId: '',
    lacId: '',
    wardId: roleFormState.ward?.id ?? '',
    gramPanchayatId: isGrampanchayat ? roleFormState.gram_panchayat?.id : '',
    villageId: !isGrampanchayat ? roleFormState.village?.id : '',
    facilityId: isFieldLevelUser
      ? formStateForField?.health_facility_name?.id
      : formStateForFacility?.health_facility_name?.id ?? '',
    urbanRuralId: roleFormState.rural_urban?.id ?? '',
    urbanRuralValue: roleFormState.rural_urban?.value ?? '',
    isFacilityLevel: isFacilityFieldLevelUser,
    isGrampanchayat: isGrampanchayat,
    parentUserId: '',
    parentUsertypeId: '',
    parentRoleId: '',
    imageData: '',
    description: '',
    url: '',
    consent_template_details: consentNeeded
      ? consentDetails?.length === 0
        ? null
        : consentDetails.map((item) => ({ consent_template_id: item.consent_template_id }))
      : null,
    processType: 'reg_through_other_user',
    verificationProcessId: verificationProcessId || '',
  };
};
